import React from "react";
import "./Loader.css";

function Loader({ message = "Loading..." }) {
  return (
    <div className="loader-wrapper">
      <div className="spinner" />
      <p>{message}</p>
    </div>
  );
}

export default Loader;
